export enum AnswerTypeEnum {
  LIKERT = "LIKERT",
  LIKERT_NA = "LIKERT_NA",
  STRING = "STRING",
  VRIDDHI = "VRIDDHI",
}
